import Chart from "chart.js/auto";
import { Radio, Select, Tabs } from "antd";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { getDashboardData } from "../../../actions/dashboardActions";
import { useTranslation } from "react-i18next";
import { getCurrentAcadimicYear } from "../../../utils/functions/javaScriptHelper";
import "./currentYearStat_v2.css";

const { TabPane } = Tabs;

const backgroundColor = [
	"#0B4A6F",
	"#065986",
	"#026AA2",
	"#0086C9",
	"#0BA5EC",
	"#36BFFA",
	"#7CD4FD",
	"#B9E6FE",
	"#98A2B3",
	"#D0D5DD",
];
const backgroundColorSmall = [
	"#026AA2",
	"#0086C9",
	"#0BA5EC",
	"#36BFFA",
	"#7CD4FD",
];
const fieldsName = ["Branch", "Campus", "Skills"];

const Dashboard = ({ dashboardData, getDashboardData }) => {
	const [branchesData, setBranchesData] = useState({});
	const [campusesData, setCampusesData] = useState({});
	const [skillsData, setSkillsData] = useState({});
	const [skillsDomain, setSkillsDomain] = useState("");
	const [skillsDomains, setSkillsDomains] = useState({});
	const [skillsDomainsList, setSkillsDomainsList] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		if (dashboardData == null) {
			getDashboardData();
		} else {
			updateChartData();
		}
	}, [dashboardData]);

	useEffect(() => {
		showStatisticsChart(fieldsName[0]);
	}, [branchesData]);

	useEffect(() => {
		showStatisticsChart(fieldsName[2]);
	}, [skillsDomain]);

	const updateChartData = () => {
		const sortObject = (objToSort, numItems = 10) => {
			const objEntries = Object.entries(objToSort);
			objEntries.sort((a, b) => b[1] - a[1]);
			const sortedObj = Object.fromEntries(objEntries.slice(0, numItems));

			return sortedObj;
		};

		if (dashboardData.branches) {
			const sortedBranches = sortObject(dashboardData.branches);

			const labels = Object.keys(sortedBranches);
			const values = Object.values(sortedBranches);

			setBranchesData({ labels, values });
		}
		if (dashboardData.campuses) {
			const sortedCampuses = sortObject(dashboardData.campuses);

			const labels = Object.keys(sortedCampuses);
			const values = Object.values(sortedCampuses);

			setCampusesData({ labels, values });
		}
		if (dashboardData.skills) {
			let tempSkillsData = {};
			const skillsDomainMap = {};

			for (let skillDomain of Object.keys(dashboardData.skills)) {
				const sortedSkills = sortObject(dashboardData.skills[skillDomain], 5);

				const labels = Object.keys(sortedSkills);
				const values = Object.values(sortedSkills);
				tempSkillsData[skillDomain] = { labels, values };

				let totalCandidates = 0;
				for (const key in dashboardData.skills[skillDomain]) {
					totalCandidates += dashboardData.skills[skillDomain][key];
				}
				skillsDomainMap[skillDomain] = totalCandidates;
			}

			let domainsList = Object.keys(skillsDomainMap);
			domainsList.sort((a, b) => skillsDomainMap[b] - skillsDomainMap[a]);
			domainsList = domainsList.slice(0, 8);

			setSkillsDomains(skillsDomainMap);
			setSkillsDomainsList(domainsList);
			setSkillsDomain(domainsList[0]);
			setSkillsData(tempSkillsData);
		}
	};

	const showStatisticsChart = async (fieldName, depth = 1) => {
		var chart = document.getElementById(fieldName);

		if (chart == null) {
			await new Promise((resolve) => setTimeout(resolve, 100));
			if (depth >= 50) return "Can not Display Graph";
			return showStatisticsChart(fieldName, depth + 1);
		}

		let chartStatus = Chart.getChart(fieldName);
		if (chartStatus != undefined) {
			chartStatus.destroy();
		}

		let statisticData = {
			Branch: branchesData,
			Campus: campusesData,
			Skills: skillsData[skillsDomain],
		};

		new Chart(chart, {
			type: "doughnut",
			data: {
				labels: statisticData[fieldName]?.labels || [],
				datasets: [
					{
						data: statisticData[fieldName]?.values || [],
						backgroundColor:
							fieldName == fieldsName[2]
								? backgroundColorSmall
								: backgroundColor,
						borderWidth: 0,
					},
				],
			},
			options: {
				cutout: "30%",
				responsive: true,
				plugins: {
					legend: {
						display: false,
						position: "right",
						labels: {
							usePointStyle: true,
							boxHeight: 7,
							padding: 22,
						},
					},
				},
				animation: {
					duration: 1500,
				},
			},
		});
	};

	const graphElement = (fieldInx) => {
		let graphData = [branchesData, campusesData, skillsData[skillsDomain]];
		return (
			<div className="graph">
				<div className="chart">
					<canvas
						id={fieldsName[fieldInx]}
						style={{
							maxHeight: 200,
						}}
					/>
				</div>
				<div className="labels">
					{graphData[fieldInx]?.labels?.map((label, inx) => {
						if (graphData[fieldInx].values[inx] > 0)
							return (
								<div className="label">
									<div
										style={{
											width: 13,
											height: 13,
											borderRadius: "50%",
											backgroundColor:
												fieldInx == 2
													? backgroundColorSmall[inx]
													: backgroundColor[inx],
										}}
									/>

									<div>
										{label} : {graphData[fieldInx].values[inx]}
									</div>
								</div>
							);
					})}
				</div>
			</div>
		);
	};

	return (
		<div className="candidates-data">
			<div className="title">
				<div>
					{t("dashboard_sectiontitle_currentYearStat_segment1")}
					{getCurrentAcadimicYear()}:
				</div>
				<div className="number">{dashboardData?.potentialCandidates}</div>
				<div>{t("dashboard_sectiontitle_currentYearStat_segment2")}</div>
			</div>

			<Tabs
				size="small"
				defaultActiveKey="0"
				centered
				style={{ width: "100%" }}
				onChange={(e) => {
					showStatisticsChart(fieldsName[e]);
				}}
			>
				<TabPane tab="Branch" key="0">
					{graphElement(0)}
				</TabPane>
				<TabPane tab="Campus" key="1">
					<div style={{ padding: "0 15%" }}>{graphElement(1)}</div>
				</TabPane>
				<TabPane tab="Skills" key="2">
					<div className="skill-tab">
						<Radio.Group
							className="domains"
							onChange={(e) => {
								setSkillsDomain(e.target.value);
							}}
							value={skillsDomain}
						>
							{skillsDomainsList.map((domain) => {
								if (skillsDomains[domain] > 0)
									return (
										<Radio value={domain} className="text">
											{domain} : {skillsDomains[domain]}
										</Radio>
									);
							})}
						</Radio.Group>
						{graphElement(2)}
					</div>
				</TabPane>
			</Tabs>
		</div>
	);
};

const mapStateToProps = (state) => ({
	dashboardData: state.organisationData.dashboardData,
});

export default connect(mapStateToProps, {
	getDashboardData,
})(Dashboard);
